module.exports = __webpack_public_path__ + "img/home.0260d232.svg";